import React from 'react';
import {
  Box,
  Grid,
  Typography,
  CircularProgress,
  Alert,
  Button,
} from '@mui/material';
import { useTranslation } from 'react-i18next';
import PostCard from './PostCard';

const PostList = ({
  posts = [],
  loading = false,
  error = null,
  columns = 2,
  showLoadMore = false,
  onLoadMore = null,
  loadingMore = false
}) => {
  const { t } = useTranslation();

  if (loading && posts.length === 0) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', py: 8 }}>
        <CircularProgress />
      </Box>
    );
  }

  if (error) {
    return (
      <Alert severity="error" sx={{ my: 4 }}>
        {t('blog.errorLoading', 'Failed to load posts. Please try again.')}
      </Alert>
    );
  }

  if (!loading && posts.length === 0) {
    return (
      <Box sx={{ textAlign: 'center', py: 8 }}>
        <Typography variant="h6" color="text.secondary" gutterBottom>
          {t('blog.noPosts', 'No posts found')}
        </Typography>
        <Typography variant="body2" color="text.secondary">
          {t('blog.noPostsDescription', 'Check back later for new content.')}
        </Typography>
      </Box>
    );
  }

  const mdCols = columns === 1 ? 12 : columns === 2 ? 6 : 4;
  const smCols = columns === 1 ? 12 : 6;

  return (
    <Box>
      <Grid container spacing={3}>
        {posts.map((post) => (
          <Grid
            item
            xs={12}
            sm={smCols}
            md={mdCols}
            key={post.id}
          >
            <PostCard post={post} />
          </Grid>
        ))}
      </Grid>

      {showLoadMore && onLoadMore && (
        <Box sx={{ display: 'flex', justifyContent: 'center', mt: 5 }}>
          <Button
            onClick={onLoadMore}
            variant="contained"
            size="large"
            disabled={loadingMore}
            sx={{ px: 5, py: 1.5, borderRadius: 2, fontWeight: 700 }}
          >
            {loadingMore ? (
              <CircularProgress size={22} color="inherit" />
            ) : (
              t('blog.loadMore', 'Load More')
            )}
          </Button>
        </Box>
      )}
    </Box>
  );
};

export default PostList;
